var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.modal.title,"ok-only":_vm.modal.okOnly},on:{"ok":_vm.handleModalOk}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.modal.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }